// This is a mixin which provides an object with the ability to set and manage a state on the html class values using BEM style modifiers.
// Pass in obj to extend the obj's prototype with the methods.

export function MixinHtmlClassState(obj) {
    mixinMethods(obj);
}

function mixinMethods(obj) {
    Object.assign(obj.__proto__, {

        hasRequiredHtmlClassStateProperties(options={}) {
            if (typeof this.element === 'undefined' || this.element === null) { return false }
            const htmlClass = options['htmlClass'] || this.baseHtmlClass;
            if (typeof htmlClass === 'undefined' || htmlClass === null) { return false }
            return true;
        },

        addHtmlClassState(state, options = {}) {
            if (state === null) { return }
            if (!this.hasRequiredHtmlClassStateProperties(options)) return;
            this.element.classList.add(this.htmlClassNameForState(state, options));
        },

        removeHtmlClassState(state, options = {}) {
            if (state === null) { return }
            if (!this.hasRequiredHtmlClassStateProperties(options)) return;
            this.element.classList.remove(this.htmlClassNameForState(state, options));
        },

        toggleHtmlClassState(state, options = {}) {
            if (state === null) { return }
            if (!this.hasRequiredHtmlClassStateProperties(options)) return;
            this.element.classList.toggle(this.htmlClassNameForState(state, options));
        },

        conditionallySetHtmlClassState(condition, state, options = {}) {
            (!!condition) ? this.addHtmlClassState(state, options) : this.removeHtmlClassState(state, options);
        },

        swapHtmlClassStates(condition, true_state, false_state, options={}) {
            if (!!condition) {
                this.addHtmlClassState(true_state, options);
                this.removeHtmlClassState(false_state, options)
            } else {
                this.addHtmlClassState(false_state, options);
                this.removeHtmlClassState(true_state, options);
            }
        },

        selectHtmlClassState(state, states=[], options = {}) {
            states.forEach((s)=>{
            if (s === state) {
              this.addHtmlClassState(s, options);
            } else {
              this.removeHtmlClassState(s, options);
            }
          });
        },

        hasHtmlClassState(state, options={}) {
            if (state === null) { return false }
            return this.element.classList.contains(this.htmlClassNameForState(state, options))
        },

        /**
         * Looks at the HTML classes applied to the element and extracts the modifiers on the base HTML class, returning them as an array of strings.
         * eg. for a class attribute of "foo foo--bar foo--baz" it will return `['bar', 'baz']`.
         * @returns {string[]}
         */
        getStatesFromHtmlClasses(options={}) {
            const htmlClass = options['htmlClass'] || this.baseHtmlClass;
            const prefix = `${htmlClass}--`;
            let htmlClasses = Array.from(this.element.classList);
            let stateClasses = htmlClasses.filter((htmlClass)=>{
                return htmlClass.startsWith(prefix)
            });
            return stateClasses.map((stateClass)=>{
                return stateClass.substring(prefix.length);
            });
        },

        htmlClassNameForState(state, options = {}){
            if (state === null) { return }
            const htmlClass  = options['htmlClass'] || this.baseHtmlClass;
            return `${htmlClass}--${state}`
        }

    });
}
